import React from 'react';
import { Calendar, X } from 'lucide-react';

interface DateTimeRangeFilterProps {
  startDate?: string;
  endDate?: string;
  onStartDateChange: (date: string | undefined) => void;
  onEndDateChange: (date: string | undefined) => void;
  onClear: () => void;
  className?: string;
}

const DateTimeRangeFilter: React.FC<DateTimeRangeFilterProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onClear,
  className = ''
}) => {
  const formatDateTimeLocal = (dateString?: string) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    // Convert to local datetime-local format (YYYY-MM-DDTHH:MM)
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    onStartDateChange(value ? new Date(value).toISOString() : undefined);
  };

  const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    onEndDateChange(value ? new Date(value).toISOString() : undefined);
  };

  const hasActiveFilters = startDate || endDate;

  return (
    <div className={`flex flex-col sm:flex-row gap-4 items-start sm:items-center ${className}`}>
      <div className="flex items-center space-x-2">
        <Calendar className="h-4 w-4 text-gray-400" />
        {/* <span className="text-sm font-medium text-gray-300">Filter by date range:</span> */}
      </div>
      
      <div className="flex flex-col sm:flex-row sm:items-center gap-3">
        <div className="flex flex-col">
          <label className="text-xs text-gray-400 mb-1">From</label>
          <input
            type="datetime-local"
            value={formatDateTimeLocal(startDate)}
            onChange={handleStartDateChange}
            className="px-3 py-2 bg-gray-700 border border-gray-600 rounded-md text-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Start date"
          />
        </div>
        
        <div className="flex flex-col">
          <label className="text-xs text-gray-400 mb-1">To</label>
          <input
            type="datetime-local"
            value={formatDateTimeLocal(endDate)}
            onChange={handleEndDateChange}
            className="px-3 py-2 bg-gray-700 border border-gray-600 rounded-md text-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="End date"
          />
        </div>
        
        {hasActiveFilters && (
          <button
            onClick={onClear}
            className="flex items-center justify-center w-8 h-8 bg-gray-600 hover:bg-red-600 text-gray-300 hover:text-white rounded-full transition-all duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 focus:ring-offset-gray-800"
            title="Clear date filters"
          >
            <X className="h-4 w-4" />
          </button>
        )}
      </div>
    </div>
  );
};

export default DateTimeRangeFilter;
